import MinhaConta from '../pages/Inicio/MinhaConta/Menu'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Menu'
import Usuarios from '../pages/Admin/Usuarios/Menu'
import Categorias from '../pages/Admin/Categorias/Menu'
import Classificados from '../pages/Sistema/Classificados/Menu'
import Galerias from '../pages/Sistema/Galerias/Menu'
import Noticias from '../pages/Sistema/Noticias/Menu'
import Destaques from '../pages/Sistema/destaques/Menu'
import Publicidades from '../pages/Sistema/Publicidades/Menu'
import Paginas from '../pages/Sistema/Paginas/Menu'
import Videos from '../pages/Sistema/Videos/Menu'

const MenuDefault = [{
	titulo: 'Início',
	icone: 'menu-icon fa fa-tachometer',
	action: false,
	visualizar: false,
	submenu: [...MinhaConta]
},
{
	titulo: 'Sistema',
	icone: 'menu-icon fa fa-desktop',
	action: false,
	visualizar: false,
	submenu: [...Classificados, ...Galerias, ...Destaques, ...Noticias, ...Paginas, ...Publicidades, ...Videos]
},
{
	titulo: 'Admin',
	icone: 'menu-icon fa fa-cog',
	action: false,
	visualizar: false,
	submenu: [...Categorias, ...GrupoDeAcesso, ...Usuarios,]
}]

export default MenuDefault
